import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=1ffb3b12"
import script from "./Container.vue?vue&type=script&lang=ts"
export * from "./Container.vue?vue&type=script&lang=ts"
import style0 from "./Container.vue?vue&type=style&index=0&id=1ffb3b12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports